module.exports = __webpack_public_path__ + "static/Adieu-Black-9aecf3e0dd5d83f704aa4211c6bed754.woff";